import React from "react";
import Modal from "../shared/Modal";
import CustomButton from "../shared/CustomButton";
import { CloseMD, parseHTMLTags, t } from "../normalizer";

// Informational help popup. Renders static help text supplied via `helpText`
// prop (sourced from wallet config or i18n fallback). No API call needed.
const VoucherHelpModal = ({ show, onClose, helpText }) => {
  if (!show) return null;

  // `helpText` (voucher_type.terms_text) comes from the API with its HTML
  // tags escaped (e.g. "&lt;div&gt;"). Decoding them before handing the
  // string to `dangerouslySetInnerHTML` lets the browser parse them as real
  // markup instead of printing the escaped tags as literal text.
  const decodedHelpText = helpText
    ? parseHTMLTags(helpText)
    : t("gamification2026.voucher.help.empty");

  return (
    <Modal show={show} untoggle={onClose} small>
      <div className="gl2026-modal__header noborder">
        <h4 className="gl2026-modal__title">
          {t("gamification2026.voucher.help.title")}
        </h4>
        <button
          type="button"
          className="gl2026-modal__close"
          onClick={onClose}
          aria-label={t("gamification2026.voucher.modal.close")}
        >
          <CloseMD />
        </button>
      </div>

      <div className="gl2026-modal__body">
        <div
          className="voucher-help-text"
          dangerouslySetInnerHTML={{ __html: decodedHelpText }}
        ></div>
      </div>

      <div className="gl2026-modal__footer">
        <CustomButton type="button" onClick={onClose}>
          {t("gamification2026.voucher.modal.ok")}
        </CustomButton>
      </div>
    </Modal>
  );
};

export default VoucherHelpModal;
